import type { ElementOrComponent } from "@/base/types"
import React from "react"

export function renderElementOrComponent(
  Component: ElementOrComponent | null | undefined,
) {
  return typeof Component === "function" ? <Component /> : (Component ?? null)
}
